<ng-container *ngIf="!errorLoading && patient">
  <div class="container" style="direction: rtl; text-align: center; padding: 2em;">
    <div style="margin: 2em 0;">
      <h1>תודה ולהתראות!</h1>
      <!-- <h3>{{ patient.First }} {{ patient.Last }}</h3> -->
      <!-- <p style="font-size: 1.1em; margin-top: 1em;">
        הפרטים שלך נשמרו בהצלחה במערכת. 
        <br />
        צוות המרפאה יצור קשר אתך כדי לתאם תור בהקדם האפשרי.
      </p> -->
    </div>
    <!-- <button (click)="goHome()" class="blue-btn" style="margin-top: 2em;">
      חזור לעמוד הבית
    </button> -->
  </div>
</ng-container>

<ng-container *ngIf="errorLoading">
  <div class="container" style="direction: rtl; text-align: center; padding: 2em;">
    <h2 style="color: red;">שגיאה בטעינת הדף</h2>
  </div>
</ng-container>
